
import { defineComponent } from "vue";

import { getCurrentUser, setCurrentUser} from "@/utils/index"
import { getAccountDetailsData } from "@/api/dashboard"
import { getPCPAcountDetails } from "@/api/pcp"

export default defineComponent({
  name: "account-details",
  components: {
  },
  data() {
    return {
      currentUsid: "",
      user: "",
      accountdetailsdata: {},
      oviRankImage: "",
      rankPrimeImage : "",
      showRankImage : true,
      loadingBalance: true,
      pt : "",
      isBiboPremium : false,
      ccode : -1,
      packageType : '',
      pcpdetails : {}
    }
  },
  setup() {  
    return { 
       
    };
  },
  methods: {
    async getPCPAcountDetailsFN(){
      const response = await getPCPAcountDetails();
      
      if(this.packageType == 'PCP'){
          if(response.data.pcpdetails !== undefined && response.data.pcpdetails !== null) {
            this.pcpdetails = response.data.pcpdetails;
          }
      }
    },

    async getAccountDetailsData() {
      const response = await getAccountDetailsData();

        if(response.data !== undefined ) {
           this.accountdetailsdata = response.data; 
          this.oviRankImage = "media/ovi_ranks/" + response.data.oviRank + ".png";

          if(response.data.rankPrime ==  'SEP' || response.data.rankPrime == 'GEP' || response.data.rankPrime == 'GAP'){
            this.rankPrimeImage = "media/rank_logos/" + response.data.rankPrime + "_header.png";
          } else {
            if(response.data.currentRank != "DI"){
              this.rankPrimeImage = "media/rank_logos/" + response.data.currentRank + "_header.png";
            } else {
              this.showRankImage = false;
            }
          }

          this.isBiboPremium = response.data.isBiboPremium;
        }
        if(response.data.isOviSealProformActive) {
            let allowChangeName = false;
            
            if(response.data.firstCoverage !== undefined && response.data.firstCoverage !== null) {
              if(response.data.firstCoverage.coverage_transtype === 'IMMEDIATE') {
                  allowChangeName = true;
              }
              
            }
        }

        
        this.loadingBalance = false;
    },
  },
  mounted() {
      let user = getCurrentUser();
      this.user = getCurrentUser();

       if(user !== undefined){
        this.currentUsid = user.usid ;
      }

      this.getAccountDetailsData(); 
      this.getPCPAcountDetailsFN();
      this.pt = String(localStorage.getItem("pt"));
      this.ccode = Number(localStorage.getItem("ccode"));
      this.packageType = String(localStorage.getItem("pVaAcNkPaOgGeItRyEpAeL"));
  }
});
